import { atom } from 'recoil';
const deliveryAddress = atom({
  key: 'deliveryAddress',
  default: undefined
});
export const isCustomAddress = atom({
  key: 'isCustomAddress',
  default: false
});
export const isAddressFormValid = atom({
  key: 'isAddressFormValid',
  default: false
});
export default deliveryAddress;